@if (showUtcChangeBanner) {
  <div class="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-between gap-4 px-4 py-3 bg-white text-gray-800 border-b border-gray-200 shadow-md">
    <p class="text-sm font-medium flex-1">
      Your system timezone (UTC) has changed. Please refresh the page to update dates and times correctly.
    </p>
    <bk-button
      variant="primary"
      size="sm"
      label="Refresh page"
      [loading]="false"
      [disabled]="false"
      buttonClass="text-white bg-[#141414] shrink-0 !py-[5px] rounded-md"
      (clicked)="refreshPage()">
    </bk-button>
  </div>
}
<router-outlet></router-outlet>
